import { render, staticRenderFns } from "./StrdPD_Details.vue?vue&type=template&id=8e62b630"
import script from "./StrdPD_Details.vue?vue&type=script&lang=js"
export * from "./StrdPD_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports